export default "__VITE_ASSET__6c99dc01__"